import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=4cf34b56"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=4cf34b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports